module.exports = __webpack_public_path__ + "static/invest-be0fcb67d8de2701756d2fe35aa68d24.png";